export default __webpack_public_path__ + "static/media/roadmap.dd707746.png";